import { render } from "./ActivateSuccess.vue?vue&type=template&id=763fc7f4&scoped=true"
import script from "./ActivateSuccess.vue?vue&type=script&lang=js"
export * from "./ActivateSuccess.vue?vue&type=script&lang=js"

import "./ActivateSuccess.vue?vue&type=style&index=0&id=763fc7f4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763fc7f4"]])

export default __exports__